import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const LoadingRadialStyle = styled.div<SpaceProps & LayoutProps>`
  border-top: ${tokens.radii.s} solid ${tokens.colors.gray};
  border-right: ${tokens.radii.s} solid ${tokens.colors.gray};
  border-bottom: ${tokens.radii.s} solid ${tokens.colors.gray};
  border-left: ${tokens.radii.s} solid ${tokens.colors.primary};
  transform: translateZ(0);
  animation: loader-animation 1.1s infinite linear;
  width: 57px;
  height: 57px;
  margin: 0 auto;
  border-radius: ${tokens.radii.l};

  &:after {
    width: 57px;
    height: 57px;
    border-radius: ${tokens.radii.l};
  }

  ${space};
  ${layout};

  @keyframes loader-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
